import styled, { createGlobalStyle } from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Button from 'builder/components/Button'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  background-color: ${Colors.White};
  overflow: hidden;
  transition: background-color 0.4s ease;
`

export const Navbar = styled.div`
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  width: 100%;
  padding: 22px 32px;
  z-index: 100;

  ${Media.Phone`
    height: 46px;
    padding: 0 20px;
  `};
`

export const StepsWrapper = styled.div`
  position: absolute;
  width: 700px;
  left: calc(50% - 350px);
  display: flex;
  align-items: center;
  justify-content: center;

  ${Media.Tablet`
    display: none;
  `};
`

export const Main = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`

export const SkipButton = styled(Button)`
  color: ${Colors.Blue50};
  background-color: rgba(26, 145, 240, 0.1) !important;
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    background-color: rgba(26, 145, 240, 0.3) !important;
  }
`

export const HeaderButtonsContainer = styled.div`
  display: flex;
  gap: 4px;

  ${Media.Tablet`
    margin-top: 10px;
  `};

  ${Media.Phone`
    margin-top: 20px
  `};
`

export const CloseButton = styled.a`
  margin-top: auto;
  margin-bottom: auto;
  width: 24px;
  height: 24px;
  color: ${Colors.Neutral30};
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${Colors.Blue50};
  }
`

export const Title = styled.h6`
  display: block;
  color: var(--Blue-Blue-50, #1a91f0);
  text-align: center;
  /* [Mobile]/M */
  font-size: 27px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 111.111% */
  margin: 10px auto;
  ${Media.Phone`
    display: none;
  `}
`

// Hide Helpscout Beacon on this page
export const GlobalStyle = createGlobalStyle`
  #beacon-container {
    display: none;
  }
`
